import { useCallback } from "react";
import { useApolloClient } from "@apollo/client/react";
import { IssueListGroupCountsDocument, IssuesDocument } from "#app/lib/data";

export function useRefetchIssueGroups(): () => Promise<unknown> {
  const apolloClient = useApolloClient();
  return useCallback(
    () => apolloClient.refetchQueries({ include: [IssuesDocument, IssueListGroupCountsDocument] }),
    [apolloClient],
  );
}
